import api from "./api";

const courseService = {
  getAllCourses: async (params = {}) => {
    const response = await api.get("/api/college/courses", { params });
    return response.data.data || response.data;
  },

  getCourseById: async (id) => {
    const response = await api.get(`/api/college/courses/${id}`);
    return response.data.data || response.data;
  },

  createCourse: async (formData) => {
    const response = await api.post("/api/college/courses", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data.data || response.data;
  },

  updateCourse: async (id, formData) => {
    const response = await api.put(`/api/college/courses/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data.data || response.data;
  },

  deleteCourse: async (id) => {
    const response = await api.delete(`/api/college/courses/${id}`);
    return response.data.data || response.data;
  },
};

export default courseService;
